export const STEP_LANDING = 'STEP_LANDING';
export const STEP_EMAIL_VERIFICATION = 'STEP_EMAIL_VERIFICATION';
export const STEP_PLATFORM_SELECTION = 'STEP_PLATFORM_SELECTION';
export const STEP_PLATFORM_FETCHER = 'STEP_PLATFORM_FETCHER';
export const STEP_REDEMPTION_SUCCESS = 'STEP_REDEMPTION_SUCCESS';
export const STEP_ADDITIONAL_INFO = 'STEP_ADDITIONAL_INFO';
export const STEP_REDEMPTION_ERROR = 'STEP_REDEMPTION_ERROR';
export const STEP_OWN_ALL_ITEMS_ERROR = 'STEP_OWN_ALL_ITEMS_ERROR';
export const STEP_LOGIN = 'STEP_LOGIN';
export const STEP_ITEMS_DISPLAY_PAGE = 'STEP_ITEMS_DISPLAY_PAGE';
export const STEP_ITEM_SELECTION_PAGE = 'STEP_ITEM_SELECTION_PAGE';
export const STEP_OWNERSHIP_CHECK = 'STEP_OWNERSHIP_CHECK';
export const STEP_CODE_CHECK = 'STEP_CODE_CHECK';
export const STEP_CHECK_STATUS = 'STEP_CHECK_STATUS';
